import Select from 'react-select';

const HEIGHT = '46px';
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: HEIGHT,
    height: HEIGHT,
    fontSize: '16px',
    fontWeight: 500,
    color: '#3a3a3a',
    border: '1px solid #d1d5db',
    borderRadius: '8px',
    backgroundColor: '#f9fafb',
    boxShadow: state.isFocused ? '0 0 0 3px rgba(0, 88, 163, 0.12)' : 'none',
    outline: 'none',
    cursor: 'pointer',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '0 14px',
    height: HEIGHT,
    flexWrap: 'nowrap',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: HEIGHT,
  }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided) => ({ ...provided, padding: '0 8px' }),
  input: (provided) => ({ ...provided, margin: '0', padding: '0' }),
  placeholder: (provided) => ({
    ...provided,
    color: '#9ca3af',
    margin: '0',
  }),
  singleValue: (provided) => ({
    ...provided,
    fontFamily: 'Noto IKEA',
    color: '#111827',
    margin: '0',
  }),
  menu: (provided) => ({
    ...provided,
    fontFamily: 'Noto IKEA',
    fontSize: '16px',
    borderRadius: '6px',
    zIndex: 10,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '10px',
    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
    color: '#3a3a3a',
    fontFamily: 'Noto IKEA',
    cursor: 'pointer',
    opacity: state.isDisabled ? 0.5 : 1,
  }),
};

export default function StoreLocationSelect({
  options = [],
  value,
  onChange,
  placeholder = '-Select-',
  isSearchable = false,
  isDisabled = false,
  className,
  ...rest
}) {
  const formattedOptions = options.map((opt) => ({
    value: opt.id,
    label: opt.StoreLocation,
    raw: opt,
  }));

  const formattedValue = formattedOptions.find((opt) => opt.value === value?.id) || null;

  const handleChange = (selected) => {
    if (selected) {
      onChange(selected.raw);
    } else {
      onChange(null);
    }
  };

  return (
    <Select
      options={formattedOptions}
      value={formattedValue}
      onChange={handleChange}
      placeholder={placeholder}
      styles={customStyles}
      isSearchable={isSearchable}
      isDisabled={isDisabled}
      className={className}
      {...rest}
    />
  );
}
